import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import api from '../services/api';

const TrainingPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [lists, setLists] = useState([]);
  const [selectedList, setSelectedList] = useState('');
  const [direction, setDirection] = useState('1to2');
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchLists();
  }, []);

  const fetchLists = async () => {
    try {
      const response = await api.get('/lists');
      // Filter lists that have vocabularies (API returns vocabCount)
      const listsWithVocab = response.data.filter(
        (list) => (list.vocabCount || list.vocabularyCount || 0) > 0
      );
      setLists(listsWithVocab);

      if (listsWithVocab.length > 0) {
        setSelectedList(listsWithVocab[0].id.toString());
      }
    } catch (err) {
      setError(err.message || t('errors.serverError'));
    } finally {
      setIsLoading(false);
    }
  };

  const handleStartTraining = () => {
    if (!selectedList) return;
    navigate(`/training/${selectedList}?direction=${direction}`);
  };

  if (isLoading) {
    return (
      <div className="app-loading">
        <div className="spinner"></div>
      </div>
    );
  }

  return (
    <div>
      <h1 className="page-title">{t('training.title')}</h1>

      {error && (
        <div className="form-error" style={{ marginBottom: '1rem' }}>
          {error}
        </div>
      )}

      {lists.length === 0 ? (
        <div className="empty-state">
          <div className="empty-state-icon">
            <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
              <rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect>
              <line x1="8" y1="21" x2="16" y2="21"></line>
              <line x1="12" y1="17" x2="12" y2="21"></line>
            </svg>
          </div>
          <h2 className="empty-state-title">{t('training.noVocabularies')}</h2>
          <p>{t('lists.createFirst')}</p>
          <button
            className="btn btn-primary"
            onClick={() => navigate('/lists')}
            style={{ marginTop: '1rem' }}
          >
            {t('nav.lists')}
          </button>
        </div>
      ) : (
        <div className="card" style={{ marginTop: '1rem' }}>
          <div className="form-group">
            <label htmlFor="list" className="form-label">
              {t('training.selectList')}
            </label>
            <select
              id="list"
              className="form-input"
              value={selectedList}
              onChange={(e) => setSelectedList(e.target.value)}
            >
              {lists.map((list) => (
                <option key={list.id} value={list.id}>
                  {list.name} ({list.vocabCount || list.vocabularyCount || 0} {t('lists.vocabularies')})
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label className="form-label">{t('training.direction')}</label>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
              <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                <input
                  type="radio"
                  name="direction"
                  value="1to2"
                  checked={direction === '1to2'}
                  onChange={(e) => setDirection(e.target.value)}
                />
                {t('training.direction1to2')}
              </label>
              <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                <input
                  type="radio"
                  name="direction"
                  value="2to1"
                  checked={direction === '2to1'}
                  onChange={(e) => setDirection(e.target.value)}
                />
                {t('training.direction2to1')}
              </label>
              <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                <input
                  type="radio"
                  name="direction"
                  value="random"
                  checked={direction === 'random'}
                  onChange={(e) => setDirection(e.target.value)}
                />
                {t('training.directionRandom')}
              </label>
            </div>
          </div>

          <button
            className="btn btn-primary btn-block"
            onClick={handleStartTraining}
            disabled={!selectedList}
          >
            {t('training.start')}
          </button>
        </div>
      )}
    </div>
  );
};

export default TrainingPage;
